import { Tooltip } from 'antd'

import styles from './SidebarToggle.module.css'

interface SidebarToggleProps {
    collapsed: boolean
    onClick: () => void
}

/**
 * Кнопка згортання сайдбара: контур панелі з лівою колонкою і шевроном.
 * Колонка «тане», а шеврон розвертається при згортанні; при наведенні
 * шеврон зсувається у бік дії.
 */
export const SidebarToggle = ({ collapsed, onClick }: SidebarToggleProps) => {
    const label = collapsed ? 'Розгорнути меню' : 'Згорнути меню'

    return (
        <Tooltip title={label} placement="right" mouseEnterDelay={0.6}>
            <button
                type="button"
                className={`${styles['toggle']}${collapsed ? ` ${styles['collapsed']}` : ''}`}
                onClick={onClick}
                aria-label={label}
                aria-expanded={!collapsed}
            >
                <svg
                    className={styles['icon']}
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <rect className={styles['column']} x="3" y="4" width="6" height="16" rx="2.5" stroke="none" />
                    <rect x="3" y="4" width="18" height="16" rx="3" />
                    <path d="M9 4v16" />
                    <path className={styles['chevron']} d="M16.5 9.5 14 12l2.5 2.5" />
                </svg>
            </button>
        </Tooltip>
    )
}
